<template>
  <div class="c-filter">
    <div class="c-form">
      <ElForm label-width="80" inline @submit.native.prevent class="elementui-common-form-styles" v-highlight>
        <ElFormItem label-width="0">
          <ElInput v-model="keyword" placeholder="请输入关键词" style="width: 220px" @keyup.enter.native="search">
            <ElSelect v-model="searchType" slot="prepend" style="width: 64px">
              <ElOption :value="1" label="素材"></ElOption>
            </ElSelect>
            <i slot="append" @click="search" class="el-icon-search"></i>
          </ElInput>
        </ElFormItem>

        <ElFormItem label="素材游戏组">
          <el-select v-model="gameGroupId" filterable clearable placeholder="全部" style="width: 120px">
            <el-option v-for="label in GAME_GROUPS" :key="label.id" :value="label.id" :label="label.name"></el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem label="素材游戏">
          <el-select v-model="gameId" filterable clearable placeholder="全部" style="width: 120px">
            <el-option v-for="label in POPULAR_GAMES" :key="label.id" :value="label.id" :label="label.name"></el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem label="数据游戏组">
          <el-select v-model="dataGroupId" filterable clearable placeholder="全部" style="width: 120px">
            <el-option v-for="label in GAME_GROUPS" :key="label.id" :value="label.id" :label="label.name"></el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem label="数据游戏">
          <el-select v-model="dataGameId" filterable clearable placeholder="全部" style="width: 120px">
            <el-option v-for="label in GAME_GROUPS" :key="label.id" :value="label.id" :label="label.name"></el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem label="内容标签">
          <el-select v-model="labelId" multiple collapse-tags filterable clearable :multiple-limit="10" placeholder="全部">
            <el-option
              v-for="label in labelList.contentLabels"
              :key="label.id"
              :value="label.id"
              :label="label.name"
              style="width: 150px"
            ></el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem label="营销主题标签">
          <el-select v-model="typeLabelId" filterable clearable placeholder="全部" style="width: 120px">
            <el-option v-for="label in labelList.marketingLabels" :key="label.id" :value="label.id" :label="label.name"></el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem label-width="40" label="来源">
          <el-select v-model="source" clearable placeholder="全部" style="width: 120px">
            <el-option v-for="label in SOURCE_TYPES" :key="label.value" :value="label.value" :label="label.label"></el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem label="设计者">
          <el-select v-model="designerId" filterable clearable placeholder="全部" style="width: 120px">
            <el-option v-for="label in SYS_USERS" :key="label.id" :value="label.id" :label="label.name"></el-option>
          </el-select>
          <!-- <auto-complete :data="operatorData" v-model="designerId" placeholder="全部" :width="120" @on-select="handleOperator" /> -->
        </ElFormItem>
        <ElFormItem label="上传时间">
          <DateRangePicker v-model="datetime" style="width: 220px"></DateRangePicker>
        </ElFormItem>
        <ElFormItem class="bg-transparent">
          <ElButton type="primary" @click="sendEvent">查询</ElButton>
        </ElFormItem>
      </ElForm>
    </div>
  </div>
</template>
<script>
import { trim, isEmpty, isArray } from '@/common/js/utils'
import DateRangePicker from '@/components/date-range-picker'
import { initPageData, GAME_GROUPS, POPULAR_GAMES, SYS_TAGS, SYS_USERS } from '@/data/global-opts'
import { LABEL_TYPES, SOURCE_TYPES } from '@/views/material/tags/const'
const PAGE_REQUIRED_OPTS = initPageData([GAME_GROUPS, POPULAR_GAMES, SYS_TAGS, SYS_USERS])

export default {
  name: 'WorkFilter',
  components: { DateRangePicker },
  computed: {
    ...PAGE_REQUIRED_OPTS,
    SOURCE_TYPES() {
      return SOURCE_TYPES
    },
    labelList() {
      return {
        contentLabels: this.SYS_TAGS.filter((i) => i.labelType === LABEL_TYPES.CONTENT_LABEL),
        threeDLabels: this.SYS_TAGS.filter((i) => i.labelType === LABEL_TYPES.THREED_LABEL),
        marketingLabels: this.SYS_TAGS.filter((i) => i.labelType === LABEL_TYPES.MARKETING_LABEL)
      }
    }
  },
  data() {
    return {
      datetime: [],
      keyword: '',
      searchType: 1,
      labelId: [],
      gameId: '',
      gameGroupId: '',
      dataGameId: '',
      dataGroupId: '',
      designerId: '',
      typeLabelId: '',
      source: ''
    }
  },
  methods: {
    search() {
      this.sendEvent()
    },
    sendEvent() {
      const keyword = isEmpty(this.keyword) ? undefined : trim(this.keyword)
      const params = {
        imageName: this.searchType === 1 ? keyword : undefined,
        planName: this.searchType === 2 ? keyword : undefined,
        labelIdsStr: this.labelId?.length ? this.labelId.join(',') : undefined,
        gameId: this.gameId === '' ? undefined : this.gameId,
        gameGroupId: this.gameGroupId === '' ? undefined : this.gameGroupId,
        dataGameId: this.dataGameId === '' ? undefined : this.dataGameId,
        dataGroupId: this.dataGroupId === '' ? undefined : this.dataGroupId,
        typeLabelId: this.typeLabelId === '' ? undefined : this.typeLabelId,
        source: this.source === '' ? undefined : this.source,
        designerId: this.designerId === '' ? undefined : this.designerId
      }
      if (isArray(this.datetime) && this.datetime.length) {
        Object.assign(params, {
          uploadBeginTime: this.datetime[0],
          uploadEndTime: this.datetime[1]
        })
      }
      this.$emit('on-change', params)
    }
  }
}
</script>
